import { PrimaryButton } from "@/components/buttons/CommonButtons"
import { router } from "expo-router"

export const StartALoanButton = () => (
  <PrimaryButton
    onPress={() => {
      router.push("/loans")
    }}
    title={"Start a Loan"}
    testID={"start-a-loan"}
    className={"mx-1 mt-6 mb-10"}
  />
)
